export enum Cards {
    VISA = "VISA",
    MC = "MC",
    AMEX = "AMEX",
    DINERS = "DINERS",
    DISCOVER = "DISCOVER"
}

export const DEFAULT_CARDS = Object.entries(Cards).map(([value]) => ({
    value,
    label: value
}));
